import type { ResetPasswordState } from './types';

export const initialResetPasswordState: ResetPasswordState = {
  error: '',
  loading: false
};
